import React, { useContext, useEffect, useState } from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import CriteriaTab from './CriteriaTab';
import SectionsTab from './SectionsTab';
import InvitationsTab from './InvitationsTab';
import QuestionsTab from './QuestionsTab';
import { WorkspaceContext } from '../context/WorkspaceContext';
import '../styles/Table.css';

const AssessmentForm = ({ assessmentId, mode }) => {
  const [activeTab, setActiveTab] = useState("assessment");
  const {
    assessment,
    loading,
    saveAssessment
  } = useContext(AssessmentContext);
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [invitationText, setInvitationText] = useState('');
  const { selectedWorkspace } = useContext(WorkspaceContext);

  useEffect(() => {
    setName(assessment?.name ?? '');
    setSlug(assessment?.slug ?? '');
    setInvitationText(assessment?.invitationText ?? '');
  }, [assessment]);

  const handleNameChange = (e) => {
    setName(e.target.value);
    generateSlug(e.target.value);
  }

  const handleSaveAssessment = async () => {
    let assessmentData = { name, slug, invitationText, workspaceId: selectedWorkspace.id };
    await saveAssessment(assessmentData);
  };

  const generateSlug = (name) => {
    const slug = name
      .toLowerCase()
      .replace(/á/g, 'a')
      .replace(/é/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/ñ/g, 'n')      
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    setSlug(slug);
    return slug;
  };

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      {mode !== 'hidden' && (
      <div>
        {assessmentId ? (
          <div>
            <div className="tabs">
              <button
                className={activeTab === 'assessment' ? 'active' : ''}
                onClick={() => setActiveTab('assessment')}
              >
                Assessment
              </button>
              <button
                className={activeTab === 'criteria' ? 'active' : ''}
                onClick={() => setActiveTab('criteria')}
              >
                Criterios
              </button>
              <button
                className={activeTab === 'sections' ? 'active' : ''}
                onClick={() => setActiveTab('sections')}
              >
                Secciones
              </button>
              <button
                className={activeTab === 'questions' ? 'active' : ''}
                onClick={() => setActiveTab('questions')}
              >
                Preguntas
              </button>
              <button
                className={activeTab === 'invites' ? 'active' : ''}
                onClick={() => setActiveTab('invites')}
              >
                Invitaciones
              </button>
              <button
                className={activeTab === 'responses' ? 'active' : ''}
                onClick={() => setActiveTab('responses')}
              >
                Respuestas
              </button>
            </div>        
            {activeTab === 'assessment' ? (
            <div id="assessment" className="tab-content">
              <div className="data-form">
                <form onSubmit={(e) => { e.preventDefault(); handleSaveAssessment(); }}>
                  <input
                    type="text"
                    value={name}
                    onChange={handleNameChange}
                    placeholder="Assessment Name"
                    required
                  />
                  <br/>
                  <input
                    type="text"
                    value={slug}
                    readOnly
                    placeholder="Assessment Slug"
                  />
                  <br/>
                  <textarea
                    value={invitationText}
                    rows="4"
                    onChange={(e) => setInvitationText(e.target.value)}
                    placeholder="Texto de invitación"
                  />
                  <br/>
                  <button type="submit">Grabar</button>
                </form>
              </div>
            </div>
            ) : null}
            {activeTab === 'criteria' ? (
            <div id="criteria" className="tab-content">
              <CriteriaTab assessmentId={assessmentId} />
            </div>
            ) : null}
            {activeTab === 'sections' ? (
            <div id="sections" className="tab-content">
              <SectionsTab assessmentId={assessmentId} />
            </div>
            ) : null}
            {activeTab === 'questions' ? (
            <div id="questions" className="tab-content">
              <QuestionsTab assessmentId={assessmentId} />
            </div>
            ) : null}
            {activeTab === 'invites' ? (
            <div id="invites" className="tab-content">
              <InvitationsTab assessmentId={assessmentId} />
            </div>
            ) : null}
            {activeTab === 'responses' ? (
            <div id="responses" className="tab-content">
              <h2>Responses</h2>
              {/* Add your responses content here */}
            </div>
            ) : null}
          </div>
        ) : (
          <div className="center-form">
            <form onSubmit={(e) => { e.preventDefault(); handleSaveAssessment(); }}>
              <input
                type="text"
                value={name}
                onChange={handleNameChange}
                placeholder="Assessment Name"
                required
              />
              <br/>
              <input
                type="text"
                value={slug}
                readOnly
                placeholder="Assessment Slug"
              />
              <br/>
              <br/>
              <button type="submit">Grabar</button>
            </form>
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default AssessmentForm;
